import { copyToClipboard } from '@websrc/App/Helpers/copyToClipboard'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { FC } from 'react'

import * as SC from './Share.style'

export interface ShareProps {
  url: string
}

export const Share: FC<ShareProps> = ({ url }) => {
  const t = useStaticText()

  return (
    <SC.Wrapper>
      <SC.Title>{t.print_and_share.share_this_page}</SC.Title>
      <SC.Info>{t.print_and_share.share_copy_paste}</SC.Info>
      <SC.InputWrapper>
        <SC.Input disabled={true} value={url} />
        <SC.Copy onClick={() => void copyToClipboard(url)}>{t.print_and_share.copy_button}</SC.Copy>
      </SC.InputWrapper>

      <SC.SocialMediaWrapper>
        <span>{t.print_and_share.share_this_link_via}:</span>
        <SC.ShareLink href={`https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`}>
          Facebook
        </SC.ShareLink>
        <SC.ShareLink href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`}>
          Twitter
        </SC.ShareLink>
        <SC.ShareLink
          href={`https://pinterest.com/pin/create/bookmarklet/?url=${encodeURIComponent(url)}`}
        >
          Pinterest
        </SC.ShareLink>
      </SC.SocialMediaWrapper>
    </SC.Wrapper>
  )
}
